import React from "react";
import PropTypes from "prop-types";

import {useAccommodationsPage} from "../../AccommodationContext";

import TextField from "@mui/material/TextField/TextField";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";


const StepInfo = (props) => {
    const {formik} = props
    const {apartmentTypologies, apartmentCategories} = useAccommodationsPage();

    return <Stack direction="column" spacing={3} sx={{mt: 1}}>
        <TextField
            select
            required
            name="apartmentTypologyId"
            value={formik.values.apartmentTypologyId}
            onChange={formik.handleChange}
            error={formik.touched.apartmentTypologyId && Boolean(formik.errors.apartmentTypologyId)}
            helperText={formik.touched.apartmentTypologyId && formik.errors.apartmentTypologyId}
            label="Tipologia"
            fullWidth>
            {
                apartmentTypologies.map(({id, nameIt}) => (
                    <MenuItem key={id} value={id}>{nameIt}</MenuItem>
                ))
            }
        </TextField>

        <TextField
            required
            name="mq"
            value={formik.values.mq}
            onChange={formik.handleChange}
            error={formik.touched.mq && Boolean(formik.errors.mq)}
            helperText={formik.touched.mq && formik.errors.mq}
            label="Superficie (metri quadrati)"
            fullWidth
        />

        <TextField
            required
            name="numberOfBathroom"
            value={formik.values.numberOfBathroom}
            onChange={formik.handleChange}
            error={formik.touched.numberOfBathroom && Boolean(formik.errors.numberOfBathroom)}
            helperText={formik.touched.numberOfBathroom && formik.errors.numberOfBathroom}
            label="Numero di bagni"
            fullWidth
        />

        <TextField
            select
            required
            name="apartmentCategoryId"
            value={formik.values.apartmentCategoryId}
            onChange={formik.handleChange}
            error={formik.touched.apartmentCategoryId && Boolean(formik.errors.apartmentCategoryId)}
            helperText={formik.touched.apartmentCategoryId && formik.errors.apartmentCategoryId}
            label="Categoria"
            fullWidth>
            {
                apartmentCategories.map(({id, name}) => (
                    <MenuItem key={id} value={id}>{name}</MenuItem>
                ))
            }
        </TextField>
    </Stack>
}

StepInfo.propTypes = {
    formik: PropTypes.object.isRequired
};

export default StepInfo;